import {
  BarChart3,
  CalendarDays,
  Images,
  LayoutDashboard,
  ListChecks,
  PenSquare,
  Settings,
  Users2,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  to: string
  /** Rótulo visível — curto o bastante para nunca truncar na barra lateral. */
  label: string
  icon: LucideIcon
  /** Descrição usada como dica e como texto acessível complementar. */
  description: string
  /**
   * Nome acessível completo, quando o rótulo visível é abreviado.
   * Precisa conter o `label` para não violar "Label in Name" (WCAG 2.5.3).
   */
  accessibleLabel?: string
}

export const NAV_ITEMS: NavItem[] = [
  {
    to: '/',
    label: 'Painel',
    icon: LayoutDashboard,
    description: 'Visão geral do que está agendado, publicado e com problema',
  },
  {
    to: '/criar',
    label: 'Criar publicação',
    icon: PenSquare,
    description: 'Escreva, anexe mídia e escolha as contas de destino',
  },
  {
    to: '/calendario',
    label: 'Calendário',
    icon: CalendarDays,
    description: 'Veja os agendamentos e o que já foi publicado, dia a dia',
  },
  {
    to: '/publicacoes',
    label: 'Publicações',
    icon: ListChecks,
    description: 'Rascunhos, fila, publicados e falhas',
  },
  {
    to: '/biblioteca',
    label: 'Biblioteca',
    icon: Images,
    description: 'Imagens e vídeos enviados',
  },
  {
    to: '/desempenho',
    label: 'Desempenho',
    icon: BarChart3,
    description: 'Métricas das publicações já entregues',
  },
  {
    to: '/contas',
    label: 'Contas',
    icon: Users2,
    description: 'Conecte e revalide Facebook e Instagram',
    accessibleLabel: 'Contas conectadas',
  },
  {
    to: '/ajustes',
    label: 'Ajustes',
    icon: Settings,
    description: 'Preferências do workspace e da conta',
  },
]
